(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9510],{

/***/ 35482:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/bot_approval_img.fd5e79a5.jpg","height":4096,"width":2234,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgABAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAAAgP/2gAMAwEAAhADEAAAAJoKH//EABwQAQACAQUAAAAAAAAAAAAAAAECAxEABAUSMv/aAAgBAQABPwDdHHtuar5omXtF9a//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAVEQEBAAAAAAAAAAAAAAAAAAAAgf/aAAgBAwEBPwCP/9k=","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 21824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ botDetailEndUser; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/components/botDetailUser.module.scss
var botDetailUser_module = __webpack_require__(67621);
var botDetailUser_module_default = /*#__PURE__*/__webpack_require__.n(botDetailUser_module);
// EXTERNAL MODULE: ./public/assets/svg/index.jsx + 68 modules
var svg = __webpack_require__(18023);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/dynamicBotCard/index.jsx
var dynamicBotCard = __webpack_require__(71835);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./styles/components/getModal.module.scss
var getModal_module = __webpack_require__(47169);
var getModal_module_default = /*#__PURE__*/__webpack_require__.n(getModal_module);
// EXTERNAL MODULE: ./components/listWithoutcheck/index.jsx
var listWithoutcheck = __webpack_require__(45336);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
// EXTERNAL MODULE: ./components/basicForm/index.js
var basicForm = __webpack_require__(35842);
// EXTERNAL MODULE: ./redux/global/actions.js
var actions = __webpack_require__(39471);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./components/getBotModal/index.jsx

















var ModalExample = function(props) {
    var useOutsideAlerter = function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                //  console.log(ref.current,"lllllll");
                // console.log(event.target,"eeeeeee");
                if (ref.current && !ref.current.contains(event.target)) {
                //props.setbotModal(false);
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    //console.log(props, "props of get modal");
    var modalRef = react.useRef(null);
    useOutsideAlerter(modalRef);
    var leadPlatformData = props.globalData.lead_platform_main_component[0];
    var clusterData = props.globalData.cluster_main_component[0];
    var technologyData = props.data.field_get_bot_field[0];
    leadPlatformData.field_related_dropdown = "";
    clusterData.field_related_dropdown = "";
    var formData = [
        leadPlatformData,
        clusterData,
        technologyData
    ];
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState({
        message: ""
    }), 2), state = ref[0], setState = ref[1];
    //  const [dropDownState, setDropdownState] = React.useState({technology : false})
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), userName = ref1[0], setUserName = ref1[1];
    var inputChange = function(e) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    // dropdown open close
    //  const handleDropDown = (item) => {
    //    setDropdownState({
    //      ...dropDownState,
    //      [item]: !dropDownState[item],
    //    });
    //  };
    var getmodal = function() {
        props.setbotModal(false);
        document.body.style.overflow = "unset";
    };
    //  // dropdown value selected
    //  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    //    console.log(value, dropdownParent, "parent")
    //    setDropdownState({ ...dropDownState, [dropdownParent]: false });
    //    setState({ ...state, [dropdownParent]: value });
    //  };
    react.useEffect(function() {
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        setUserName(auth.name);
    });
    var sendMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setGetFormValues(true);
                return [
                    2
                ];
            });
        });
        return function sendMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref2[0], setGetFormValues = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidInputFlag = ref3[0], setInputInvalid = ref3[1];
    var recievedFormValues = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData) {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        if (state["message"] == "") {
                            setGetFormValues(false);
                            setInputInvalid(true);
                        } else {
                            setInputInvalid(false);
                            props.setLoading(true);
                            axios_default()({
                                method: "post",
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/getBot/createGetReq"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: (0,_object_spread/* default */.Z)({
                                    requestedBy: auth.email,
                                    botID: props.botID
                                }, formData, state)
                            }).then(function(res) {
                                if (res.data.code == 403) {
                                    props.sessionTimeOutCheck(true);
                                    props.setLoading(false);
                                }
                                if (res.data.code == 200) {
                                    //console.log("props ----", props);
                                    props.setBotModal(false);
                                    props.setSuccessModal(true);
                                    props.setLoading(false);
                                }
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        props.sessionTimeOutCheck(true);
                        props.setLoading(false);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function recievedFormValues(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var emptyFormValues = function() {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (getModal_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (getModal_module_default()).modalBox,
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (getModal_module_default()).modalHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (getModal_module_default()).content,
                        children: "Get this bot"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (getModal_module_default()).modalBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (getModal_module_default()).textBody,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (getModal_module_default()).texthead,
                                    children: [
                                        "Hello ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                            children: [
                                                " ",
                                                userName,
                                                ", "
                                            ]
                                        }),
                                        " thankyou for opting",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                            children: [
                                                props.botName,
                                                "."
                                            ]
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (getModal_module_default()).textbody,
                                    children: "To complete the process for getting this bot, please fill the details below and we will get back to you as soon as possible."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (getModal_module_default()).basicForm,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(basicForm["default"], {
                                formType: "getBot",
                                data: formData,
                                sendFormValues: recievedFormValues,
                                getFormValues: getFormValues,
                                setGetFormValues: setGetFormValues,
                                demandEditData: {
                                    leadPlatform: props.leadPlatform,
                                    technology: props.technology,
                                    cluster: props.cluster
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (getModal_module_default()).inputGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (getModal_module_default()).labelStyle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "Why do you want this bot?",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (getModal_module_default()).sup,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        invalidInputFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (getModal_module_default()).errorMessage,
                                            style: {
                                                color: "red",
                                                fontSize: "12px"
                                            },
                                            children: "Please fill the message"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    className: "".concat(invalidInputFlag ? (getModal_module_default()).errorBorder : null),
                                    placeholder: "Type something",
                                    onChange: inputChange,
                                    name: "message"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (getModal_module_default()).modalFooter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (getModal_module_default()).combinedBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (getModal_module_default()).rowBtn,
                                onClick: function() {
                                    return getmodal();
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (getModal_module_default()).exportListBtn,
                                onClick: function() {
                                    return sendMessage();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                        name: "enquiryicon",
                                        className: (getModal_module_default()).sendIcon
                                    }),
                                    "Send Message"
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var getBotModal = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(ModalExample));

// EXTERNAL MODULE: ./redux/storeBot/actions.js
var storeBot_actions = __webpack_require__(64362);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Loader/index.jsx
var Loader = __webpack_require__(16330);
// EXTERNAL MODULE: ./pages/successModal/index.jsx
var pages_successModal = __webpack_require__(99696);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/clipboard/dist/clipboard.js
var dist_clipboard = __webpack_require__(42152);
var clipboard_default = /*#__PURE__*/__webpack_require__.n(dist_clipboard);
// EXTERNAL MODULE: ./components/shared/config.js
var shared_config = __webpack_require__(60344);
;// CONCATENATED MODULE: ./components/botDetailEndUser/AssociateBots.jsx







var AssociateBots = function(param) {
    var parentBotID = param.parentBotID, setAssociateBotIds = param.setAssociateBotIds;
    var ref = (0,react.useState)([]), botIds = ref[0], setBotIds = ref[1];
    var getAssociatedBotIds = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var payload, config, ref, res, ref1, ref2, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = {
                            parentBotID: parentBotID
                        };
                        config = {
                            headers: {
                                Authorization: "Bearer ".concat(shared_config/* config.bearerToken */.v.bearerToken)
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!parentBotID) {
                            console.error("parentBotID is not provided.");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            axios_default().post("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/bot/similar-bots"), payload, config)
                        ];
                    case 2:
                        res = _state.sent();
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.status) === "success") {
                            ;
                            setBotIds(((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data) || []);
                            setAssociateBotIds(((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.data) || []);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error fetching associated bot IDs:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getAssociatedBotIds() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getAssociatedBotIds();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (botDetailUser_module_default()).center,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Associated Bot Ids"
                }),
                botIds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: botIds.map(function(id, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("span", {
                            children: [
                                id === null || id === void 0 ? void 0 : id.botExternalId,
                                " ",
                                index !== botIds.length - 1 && ",",
                                " "
                            ]
                        }, id);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "-"
                })
            ]
        })
    });
};
/* harmony default export */ var botDetailEndUser_AssociateBots = (AssociateBots);

// EXTERNAL MODULE: ./lib/store/useSasStore.js
var useSasStore = __webpack_require__(91345);
// EXTERNAL MODULE: ./components/botApproval/assets/bot_approval_img.jpg
var bot_approval_img = __webpack_require__(35482);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/botDetailEndUser/index.jsx
























// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faQuoteLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";






var options = {
    cMapUrl: "cmaps/",
    cMapPacked: true
};
function index(props) {
    var camelize = function camelize(str) {
        if (str === undefined) {
            return null;
        } else {
            return str.toString().replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            }).replace(/\s+/g, "");
        }
    };
    //console.log(props, "props at bot detail ");
    //const routes = props.globalData.menu_component.menu_list;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), myBot = ref[0], setMyBot = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)(); //"businessUserRegionWise", // //"businessUserRegionWise",
    var sasToken = (0,useSasStore/* useSas */.k)().sasToken;
    var ref1 = (0,react.useState)([]), associateBotIds = ref1[0], setAssociateBotIds = ref1[1];
    var ref2 = (0,react.useState)(false), reviewModal = ref2[0], setReviewModal = ref2[1];
    var convertToDDMMYYYY = function(date) {
        if (date && date != "NA") {
            var year = date.slice(0, 4);
            var month = date.slice(5, 7);
            var day = date.slice(8, 10);
            var newDate = day + "-" + month + "-" + year;
            return newDate;
        } else {
            return "--";
        }
    };
    /**
* 	
* Bot ID ---done
Lead Platform --done
Area -- done 
Sub Area - done 
Process Name --done
Process Description --done
Cluster -- Done
MCO ---  Done
Country --- Done
Technology--DOne
Primary Application --DOne
Status --done
Process Criticality --
KFA --Done
TCode --Done
Requester email ID  -done 
Business Owner Email ID --done
Created By -done
Engagement Lead -done
*/ //
    // restricted user
    /**
   * "businessUserRegionWise",
    "businessUserRegionWise",
   */ var ref3 = (0,react.useState)([
        "businessOwner",
        "endUser", 
    ]), restrictedUserBotView = ref3[0], setRestrictedUserBotView = ref3[1];
    var ref4 = (0,react.useState)(true), restrictedViewDetails = ref4[0], setRestrictedViewDetails = ref4[1];
    var restrictedUserDocumentView = [
        "businessUserRegionWise",
        "endUser",
        "businessOwner", 
    ];
    var restrictedDocumentTypes = [
        "SOP",
        "PDD"
    ];
    var allDocumentTypes = [
        "sopDocument",
        "pddDocument",
        "pddApprovalDocument",
        "sddDocument",
        "qsgDocument",
        "odiDocument",
        "brdDocument",
        "costApprovalDocument",
        "explicitLandscapeApplicationOwnerApprovalDocument",
        "explicitGPMApprovalSupplyChainFinanceDocument",
        "explicitGFCFApprovalDocument",
        "devQualityCredentialsAvailableDocument",
        "infosecApprovalDocument",
        "dAReviewSignOffDocument",
        "testDataAvailableForDevelopmentDocument",
        "requestRaisedForProductionCredentialsDocument",
        "internalTestingCompletedDocument",
        "peerReviewSignOffDocument",
        "daReviewSecondSignOffDocument",
        "bpReleaseSignOffFromDaDocument",
        "uatScriptsWithResultsDocument",
        "uatSignOffDocument",
        "releaseManagerSignOffDocument",
        "gateFormDocument",
        "peerReviewchecklistDocument",
        "qaSignOffDocument",
        "walkthroughVideo",
        "ktVideo", 
    ];
    var documentAr = [
        {
            title: "SOP",
            value: "sopDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD",
            value: "pddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD Approval",
            value: "pddApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "SDD",
            value: "sddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "QSG",
            value: "qsgDocument",
            type: [
                ".doc",
                ".docx"
            ]
        },
        {
            title: "ODI",
            value: "odiDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "BRD",
            value: "brdDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Cost Apporval",
            value: "costApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Landscape Approval",
            value: "explicitLandscapeApplicationOwnerApprovalDocument",
            type: ".msg"
        },
        {
            title: "GPM Approval",
            value: "explicitGPMApprovalSupplyChainFinanceDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "GFCF Approval",
            value: "explicitGFCFApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Dev Quality Crendentails Available",
            value: "devQualityCredentialsAvailableDocument",
            type: ".msg"
        },
        {
            title: "Infosec Approval",
            value: "infosecApprovalDocument",
            type: ".msg"
        },
        {
            title: "DA Review Sign Off",
            value: "dAReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "Test Data Development",
            value: "testDataAvailableForDevelopmentDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Request Raised Product Credentials",
            value: "requestRaisedForProductionCredentialsDocument",
            type: ".msg"
        },
        {
            title: "Internal Testing Completed",
            value: "internalTestingCompletedDocument",
            type: ".msg"
        },
        {
            title: "Peer Review Sign Off",
            value: "peerReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "DA Review Second Sign Off",
            value: "daReviewSecondSignOffDocument",
            type: ".msg"
        },
        {
            title: "BP Release Sign Off",
            value: "bpReleaseSignOffFromDaDocument",
            type: ".msg"
        },
        {
            title: "UAT Scripts With Results",
            value: "uatScriptsWithResultsDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Release Manager Sign Off",
            value: "releaseManagerSignOffDocument",
            type: ".msg"
        },
        {
            title: "Gate Form",
            value: "gateFormDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Peer Review Checklist",
            value: "peerReviewchecklistDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "QA Sign Off",
            value: "qaSignOffDocument",
            type: ".msg"
        },
        {
            title: "Walk Through Video",
            value: "walkthroughVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        },
        {
            title: "KT Video",
            value: "ktVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        }, 
    ];
    // React.useEffect(() => {
    //   for (let i in )
    // }, [])
    var ref5 = (0,react.useState)([
        "admin",
        "gfcf",
        "firstGfcf",
        "firstLevelGPMApprover",
        "GPMapprover",
        "gCad",
        "qrManager",
        "internalUser",
        "supportStatus", 
    ]), noRestrictedUser = ref5[0], setnoRestrictedUser = ref5[1];
    var ref6 = (0,react.useState)([]), documentTypes = ref6[0], setDocumentTypes = ref6[1];
    react.useEffect(function() {
        //console.log("mybotUse Effect");
        //console.log("auth --mybot", auth);
        if (myBot != null) {
            //console.log("Restricted User", restrictedUser);
            if (myBot.businessOwnerEmailID == auth.email) {
                setRestrictedViewDetails(false);
            } else if (restrictedUser.includes(auth.userType)) {
                setRestrictedViewDetails(true);
            } else {
                setRestrictedViewDetails(false);
            }
            //console.log("my bot bot detail end user ---", myBot);
            var documentsToSet = [];
            for(var i in documentAr){
                {}
                if (myBot[documentAr[i]["value"]] !== undefined && myBot[documentAr[i]["value"]] !== null && myBot[documentAr[i]["value"]] !== "" && myBot[documentAr[i]["value"]] !== "can be empty") {
                    //console.log("what Input doc-----", myBot[documentAr[i]["value"]]);
                    documentsToSet.push(documentAr[i].title);
                }
            }
            // if (myBot.botDemoVideo != undefined && myBot.botDemoVideo !== "" && myBot.botDemoVideo != undefined) {
            //   documentsToSet.push("Bot Demo Vedio");
            // }
            //console.log(documentsToSet, "DOCumentstoset");
            if (restrictedUserDocumentView.includes(auth.userType)) {
                if (auth.userType == "businessOwner") {
                    //console.log(myBot.businessOwnerEmailID, "DOCumentstoset");
                    //console.log(auth.email, "DOCumentstoset");
                    if (myBot.businessOwnerEmailID == auth.email) {
                        //console.log(documentsToSet, "DOCumentstoset");
                        setDocumentTypes((0,_to_consumable_array/* default */.Z)(documentsToSet));
                    } else {
                        var restrictedNewDocumented = [];
                        if (documentsToSet.includes("SOP")) {
                            restrictedNewDocumented.push("SOP");
                        }
                        if (documentsToSet.includes("PDD")) {
                            restrictedNewDocumented.push("PDD");
                        }
                        setDocumentTypes(restrictedNewDocumented);
                    }
                } else {
                    var restrictedNewDocumented1 = [];
                    if (documentsToSet.includes("SOP")) {
                        restrictedNewDocumented1.push("SOP");
                    }
                    if (documentsToSet.includes("PDD")) {
                        restrictedNewDocumented1.push("PDD");
                    }
                    setDocumentTypes(restrictedNewDocumented1);
                }
            } else {
                setDocumentTypes(documentsToSet);
            }
        }
    }, [
        myBot
    ]);
    console.log("botExternalId", myBot);
    var ref7 = (0,react.useState)([
        "endUser",
        "businessUserRegionWise",
        "businessOwner",
        "firstGfcf",
        "gfcf",
        "firstLevelGPMApprover",
        "GPMapprover",
        "gCad",
        "infosec",
        "landscape"
    ]), restrictedUser = ref7[0], setRestrictedUser = ref7[1];
    var ref8 = (0,react.useState)([
        "internalUser",
        "support",
        "releaseManager",
        "editAccess",
        "admin", 
    ]), allFieldsUserType = ref8[0], setallFieldsUserType = ref8[1];
    var ref9 = (0,react.useState)([
        "internalUser",
        "admin",
        "qrManager",
        "releaseManager",
        "supportStatus", 
    ]), editUser = ref9[0], setEditUser = ref9[1];
    var ref10 = (0,react.useState)(false), botModal = ref10[0], setbotModal = ref10[1];
    var ref11 = (0,react.useState)(true), Loading = ref11[0], setLoading = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), bots = ref12[0], setBots = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref13[0], setSuccessModal = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), documentDropdown = ref14[0], setDocumentDropdown = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)(react.useState("sopDocument"), 2), selectedDropdown = ref15[0], setSelectedDropdown = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), similarBots = ref16[0], setSimilarBots = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)(react.useState("pdf"), 2), currentDocumentExtension = ref17[0], setCurrentDocumentExtension = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), searchResults = ref18[0], setSearchResults = ref18[1];
    var ref19 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), documentEditState = ref19[0], setDocumentEditState = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), editedDocument = ref20[0], setEditedDocument = ref20[1];
    var ref21 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), editLoader = ref21[0], setEditLoader = ref21[1];
    var ref22 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidModal = ref22[0], setInvalidModal = ref22[1];
    react.useEffect(function() {
    //console.log(currentDocumentExtension, "currentDocument")
    }, [
        currentDocumentExtension
    ]);
    var auth = lodash_default().get(JSON.parse(localStorage.getItem("auth")), "data", "");
    var openDocumentSelector = function() {
        setDocumentDropdown(!documentDropdown);
    };
    var ref23 = (0,react.useState)(""), authData = ref23[0], setAuthData = ref23[1];
    react.useEffect(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var authCheck, expiryStatus, auth;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authCheck = lodash_default().get(JSON.parse(localStorage.getItem("auth")), "data", "");
                    return [
                        4,
                        props.checkExpiry(authCheck)
                    ];
                case 1:
                    expiryStatus = _state.sent();
                    if (expiryStatus) {
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        fetchbot(auth);
                    } else {
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                    }
                    if (router.query.searchResults) {
                        setSearchResults(true);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        router.query
    ]);
    var fetchbot = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(auth) {
            var authCheck, expiryStatus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setAuthData(auth);
                        if (!router.query.botID) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            axios_default()({
                                method: "get",
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/getBotUsingId?botID=").concat(window.atob(router.query.botID)),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(res) {
                                if (res.data.code == 200) {
                                    //   console.log(res.data.data, "data bot from response");
                                    if (res.data.data) {
                                        if (res.data.data.dateOfStatusChanged) {
                                            res.data.data.dateOfStatusChanged = res.data.data.dateOfStatusChanged.slice(0, 10);
                                        }
                                    }
                                    setMyBot(res.data.data);
                                    var initialExtensionAr = res.data.data.sopDocument.split(".");
                                    //console.log(initialExtensionAr, "initialExtensionAr");
                                    dispatch((0,storeBot_actions/* saveCurrentBot */.B1)(res.data.data));
                                    setLoading(false);
                                    if (initialExtensionAr.length > 1) {
                                        setCurrentDocumentExtension(initialExtensionAr[initialExtensionAr.length - 1]);
                                    }
                                    if (res.data.data && (res.data.data.documentLink || res.data.data.path)) {
                                        setEditedDocument(res.data.data.documentLink ? res.data.data.documentLink : res.data.data.path);
                                    }
                                    // fetching similar bots
                                    axios_default()({
                                        method: "get",
                                        url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/elastic/searchQuery"),
                                        params: {
                                            leadPlatform: res.data.data.leadPlatform
                                        },
                                        headers: {
                                            Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                        }
                                    }).then(function(resp) {
                                        if (resp.data.code == 200) {
                                            //console.log( "response of similar bots elastic")
                                            setSimilarBots(resp.data.data.allBots.filter(function(item) {
                                                return item._source.botID != res.data.data.botID;
                                            }));
                                        // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
                                        } else if (resp.data.code == 403) {
                                            localStorage.removeItem("auth");
                                            sessionStorage.clear();
                                            // router.push("/login");
                                            setLoading(false);
                                            props.sessionTimeOutCheck(true);
                                        }
                                    });
                                } else if (res.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    // router.push("/login");
                                    setLoading(false);
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            setLoading(false);
                            props.sessionTimeOutCheck(true);
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchbot(auth) {
            return _ref.apply(this, arguments);
        };
    }();
    var frameRef = react.useRef(null);
    react.useEffect(function() {
        if (props.type == "previewPage") {
            setMyBot(props.myBot);
            setLoading(false);
            var initialExtensionAr = props.myBot.sopDocument.split(".");
            //console.log(initialExtensionAr, "initialExtensionAr");
            if (initialExtensionAr.length > 1) {
                setCurrentDocumentExtension(initialExtensionAr[initialExtensionAr.length - 1]);
            }
        }
        // var iframe = document.getElementById("youriframe");
        // setTimeout(() => {
        //   if (iframe) {
        //     iframe.src = iframe.src;
        //   }
        // }, 2000);
        if (frameRef.current != null) {
            frameRef.current.contentWindow.location.reload();
        }
    //console.log(document.getElementById("youriframe"), "youriframe");
    //console.log(frameRef, "youriframe");
    }, []);
    var getBot = function() {
        var modal = !botModal;
        setbotModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var editBot = function() {
        router.push("/editBot");
    };
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        // console.log(documentAr, "DOCUMENTAR")
        // console.log(value,"valueee")
        var selectedDocument = documentAr.filter(function(item, index) {
            return item.title == value;
        });
        // console.log(selectedDocument[0].value, "selected Dropdown")
        setSelectedDropdown(selectedDocument[0].value);
        //console.log(myBot[selectedDocument[0].value], "ye value check karne ka");
        //console.log(myBot[selectedDocument[0].value], "valueeeeesss");
        var extensionAr = myBot[selectedDocument[0].value].split(".");
        var extension = extensionAr[extensionAr.length - 1];
        setCurrentDocumentExtension(extension);
        setDocumentDropdown(false);
    };
    var fixCountry = function(str) {
        var fixedString = "";
        if (props.type == "previewPage") {
        //     for (let i in str) {
        //       if (i != str.length-1){
        //         fixedString = fixedString + str[i] + ", ";
        //       }
        //       else {
        //         fixedString = fixedString+ str[i]
        //       }
        //     }
        } else {
            if (str.includes(";")) {
                str.replace(";", ",");
            }
        }
        if (fixedString[fixedString.length - 1] == ",") {
            fixedString = fixedString.slice(0, fixedString.length - 1);
        }
        return fixedString;
    };
    var changeDocumentLink = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var auth, expiryStatus, res, initialExtensionAr;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!editedDocument.trim()) return [
                            3,
                            6
                        ];
                        setEditLoader(true);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        auth = _state.sent();
                        return [
                            4,
                            props.checkExpiry(auth)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            axios_default()({
                                method: "PUT",
                                data: {
                                    botID: myBot.botID,
                                    newDocumentLink: editedDocument
                                },
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/editDocumentLink"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 3:
                        res = _state.sent();
                        setMyBot(res.data.data);
                        initialExtensionAr = res.data.data.sopDocument.split(".");
                        //console.log(initialExtensionAr, "initialExtensionAr");
                        dispatch((0,storeBot_actions/* saveCurrentBot */.B1)(res.data.data));
                        setDocumentEditState(false);
                        setEditLoader(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setInvalidModal(true);
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function changeDocumentLink() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref24 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isURLCopied = ref24[0], setIsURLCopied = ref24[1];
    var handleCopyurl = function() {
        var urlToCopy = window.location.href;
        var clipboard = new (clipboard_default())(".copy-button", {
            text: function() {
                return urlToCopy;
            }
        });
        clipboard.on("success", function(e) {
            e.clearSelection();
            setIsURLCopied(true);
        // alert('URL copied to clipboard >>>>>>>>>>>>>>>>>>>>>>---------', urlToCopy);
        });
        clipboard.on("error", function(e) {
            console.error("Failed to copy URL: ", e.action);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setSuccessModal
            }) : null,
            invalidModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setInvalidModal,
                title: "Edit document link",
                message: "Document link cannot be empty",
                fail: true
            }) : null,
            Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "800px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader["default"], {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    myBot != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (botDetailUser_module_default()).botDetailWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (botDetailUser_module_default()).detailHead,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (botDetailUser_module_default()).cardHead,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (botDetailUser_module_default()).left,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (botDetailUser_module_default()).rollBot,
                                                        onClick: function() {
                                                            router.push("/botStore");
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/less-than.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (botDetailUser_module_default()).icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                            name: camelize(myBot.leadPlatform),
                                                            className: (botDetailUser_module_default()).shoppingIcon
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (botDetailUser_module_default()).text,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (botDetailUser_module_default()).flexd,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: (botDetailUser_module_default()).code,
                                                                            children: props.createBot ? "" : myBot.botExternalId
                                                                        })
                                                                    }),
                                                                    props.createBot ? "" : myBot.requestType == "Roll Out" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).list,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                class: (botDetailUser_module_default()).tooltiptext,
                                                                                children: [
                                                                                    "Bot_Id",
                                                                                    " . ",
                                                                                    "Landscape_Id",
                                                                                    " . ",
                                                                                    "Variant_Id"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sapn", {
                                                                                className: (botDetailUser_module_default()).info,
                                                                                children: "i"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: (botDetailUser_module_default()).label,
                                                                children: myBot.leadPlatform
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (botDetailUser_module_default()).statusTagWrapper,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "".concat((botDetailUser_module_default()).label, " ").concat((botDetailUser_module_default())["".concat(status == "Design/Feasibility" ? "designFeasibility" : camelize(myBot.status), "Status")]),
                                                            children: myBot.status
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: handleCopyurl,
                                                        className: "copy-button ms-3 ",
                                                        style: {
                                                            fontSize: "30px"
                                                        },
                                                        children: isURLCopied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCheck */.bzc, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCopy */.AOF, {})
                                                    })
                                                ]
                                            }),
                                            props.type == "previewPage" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (botDetailUser_module_default()).right,
                                                children: [
                                                    !restrictedViewDetails ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center gap-3",
                                                        children: [
                                                            myBot.requestType === "New Request" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "!border !border-green-600 text-green-600 cursor-pointer h-full px-2 flex justify-center items-center",
                                                                onClick: function() {
                                                                    router.push("/change-request?botID=".concat(myBot.botID));
                                                                },
                                                                children: "Create Change Request Bot"
                                                            }),
                                                            myBot.requestType !== "Roll Out" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (botDetailUser_module_default()).backBot,
                                                                onClick: function() {
                                                                    router.push("/rolloutBot");
                                                                },
                                                                children: "Create Roll Out Bot"
                                                            })
                                                        ]
                                                    }) : null,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (botDetailUser_module_default()).getBot,
                                                        onClick: getBot,
                                                        children: "Get This Bot"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botDetailUser_module_default()).detailBody,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botDetailUser_module_default()).textualContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (botDetailUser_module_default()).txtCard,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (botDetailUser_module_default()).center,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: " PROCESS NAME"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                        children: myBot.processName
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Area"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.area
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Sub Area"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.subArea
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Domain"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: (myBot === null || myBot === void 0 ? void 0 : myBot.domain) || "-"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Family"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: (myBot === null || myBot === void 0 ? void 0 : myBot.family) || "-"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (botDetailUser_module_default()).left,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Product"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: (myBot === null || myBot === void 0 ? void 0 : myBot.product) || "-"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (botDetailUser_module_default()).center,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "PROCESS DESCRIPTION"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                                        children: [
                                                                            myBot.processDescription,
                                                                            " ",
                                                                            associateBotIds.length > 0 ? "This bot is associated with ".concat(associateBotIds.map(function(item) {
                                                                                return item.botExternalId;
                                                                            }).join(", "), " bots.") : null
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(botDetailEndUser_AssociateBots, {
                                                            parentBotID: myBot === null || myBot === void 0 ? void 0 : myBot.botExternalId,
                                                            setAssociateBotIds: setAssociateBotIds
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Cluster"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.cluster
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "MCO"
                                                                        }),
                                                                        props.type == "previewPage" && typeof myBot.mco != "string" && myBot.mco != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: lodash_default().get(myBot, "mco", []).map(function(item, index) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    children: [
                                                                                        item,
                                                                                        " ",
                                                                                        index == myBot.mco.length - 1 ? null : ","
                                                                                    ]
                                                                                });
                                                                            })
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.mco
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "COUNTRY"
                                                                        }),
                                                                        props.type == "previewPage" && typeof myBot.country != "string" && myBot.country != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: lodash_default().get(myBot, "country", []).map(function(item, index) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    children: [
                                                                                        item,
                                                                                        " ",
                                                                                        index == myBot.country.length - 1 ? null : ","
                                                                                    ]
                                                                                });
                                                                            })
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.country
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "TECHNOLOGY"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.technology
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "ET Profile"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot === null || myBot === void 0 ? void 0 : myBot.eTProfile
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Platform"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot === null || myBot === void 0 ? void 0 : myBot.platform
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (botDetailUser_module_default()).left,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "KFAS"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: myBot.kfa ? "Yes" : "No"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "KFAS TYPE"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.kfaTransactional ? "Transactional" : myBot.kfaInformational ? "Informational" : "None"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "PROCESS CRITICALITY"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.processCriticality
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "REQUESTER E-MAIL ID"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.requesterEmailID
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "T CODE"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.tCode == "NA" ? "--" : myBot.tCode
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "CREATED BY"
                                                                        }),
                                                                        props.type == "previewPage" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: auth.name
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.createdBy
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "BUSINESS OWNER E-MAIL ID"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.businessOwnerEmailID == "NA" ? "--" : myBot.businessOwnerEmailID
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (botDetailUser_module_default()).left,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Cost Approver"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: myBot.costApprover == null ? "--" : myBot.costApprover
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "HAP DELIVERY LEADS"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.engagementLead
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Catalogue Products"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.catalogueProducts ? "Yes" : "No"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).left,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Business Analyst"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.businessAnalyst
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (botDetailUser_module_default()).right,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Functional HAP SMEs"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: myBot.functionalHAPSMEs
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        restrictedUserDocumentView.includes(auth.userType) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth),
                                                            children: myBot.documentLink || myBot.path ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (botDetailUser_module_default()).center,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).documentLinkHeading,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "DOCUMENT LINKS"
                                                                            }),
                                                                            documentEditState || auth.userType != "admin" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                onClick: function() {
                                                                                    return setDocumentEditState(true);
                                                                                },
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                                        name: "pencilDark",
                                                                                        className: (botDetailUser_module_default()).editInactive
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    documentEditState ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).editRow,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                onChange: function(e) {
                                                                                    return setEditedDocument(e.target.value);
                                                                                },
                                                                                value: editedDocument,
                                                                                type: "text"
                                                                            }),
                                                                            editLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "".concat((botDetailUser_module_default()).container),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "".concat((botDetailUser_module_default()).loader, " ").concat((botDetailUser_module_default()).loader3)
                                                                                })
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                onClick: changeDocumentLink,
                                                                                children: "Save"
                                                                            })
                                                                        ]
                                                                    }) : myBot.documentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            target: "_blank",
                                                                            href: "".concat(myBot.documentLink),
                                                                            children: myBot.documentLink
                                                                        })
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            target: "_blank",
                                                                            href: "".concat(myBot.path),
                                                                            children: myBot.path
                                                                        })
                                                                    })
                                                                ]
                                                            }) : null
                                                        }),
                                                        restrictedViewDetails ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "TOOL USED"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.toolUsed
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "APPLICATIONS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.applications
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "DATE LOGGED"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: convertToDDMMYYYY(myBot.dateLogged == "2018-12-31" || myBot.dateLogged == "2018-12-30" ? "" : myBot.dateLogged)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "DELIVERY MODEL"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.deliveryModel
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).left,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "REQUEST TYPE"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: myBot.requestType
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "PARENT BOT ID"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.botType === "rollout" ? myBot.masterBotID : myBot.parentBotID ? myBot.parentBotID : "--"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "HOURS SAVED YEARLY"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.hoursSavedYearly == "NA" ? "--" : myBot.hoursSavedYearly
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "INITIATED BY"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.initiatedBy
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "DATE OF STATUS CHANGED"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "COMMENTS FOR STATUS CHANGED"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: myBot.commentsForStatusChanged ? myBot.commentsForStatusChanged : "--"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                !restrictedViewDetails ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (botDetailUser_module_default()).txtCard,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    className: (botDetailUser_module_default()).cardHeading,
                                                                    children: "Supporting Details"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "Process ID"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.processID
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "SAP ID"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.sAPID ? myBot.sAPID : "--"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "DATA CLASSIFICATION"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.dataClassification
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "REMARKS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.remarks
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "BUILD NAME"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.buildName
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "SUPPORT STATUS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.supportStatus
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "NUMBER OF RUNS IN A MONTH"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.numberOfRunsInAMonth
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "AVERAGE RUNNING TIME"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.averageTime
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (botDetailUser_module_default()).txtCard,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    className: (botDetailUser_module_default()).cardHeading,
                                                                    children: "BOT delivery dates"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).left,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "PDD SIGN OFF DATE"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: convertToDDMMYYYY(myBot.pddSignOffDate == "2018-12-30" || myBot.pddSignOffDate == "2018-12-31" ? "" : myBot.pddSignOffDate)
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).left,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "Bau Date"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: convertToDDMMYYYY(myBot.bauDate == "2018-12-31" || myBot.bauDate == "2018-12-30" ? "" : myBot.bauDate)
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "Last Modified DATE"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: convertToDDMMYYYY(myBot.lastModifiedDate == "2018-12-30" || myBot.lastModifiedDate == "2018-12-31" ? "" : myBot.lastModifiedDate)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "UAT SIGN OFF DATE"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: convertToDDMMYYYY(myBot.uATSignOffDate == "2018-12-30" || myBot.uATSignOffDate == "2018-12-31" ? "" : myBot.uATSignOffDate)
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).left,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "GO LIVE DATE"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: convertToDDMMYYYY(myBot.goLiveDate == "2018-12-30" || myBot.goLiveDate == "2018-12-31" ? "" : myBot.goLiveDate)
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (botDetailUser_module_default()).txtCard,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    className: (botDetailUser_module_default()).cardHeading,
                                                                    children: "Approvals"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "LANDSCAPE APPROVAL"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.landscapeApproval ? "Yes" : myBot.landscapeApproval === false ? "No" : "--"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "LANDSCAPE APPROVER NAME"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.landscapeApprover === undefined || myBot.landscapeApprover == "" || myBot.landscapeApprover == null ? "--" : myBot.landscapeApprover
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow)
                                                                }),
                                                                myBot.landscapeApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "LANDSCAPE APPROVAL DOCUMENT LINK"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.landscapeApprovalDocumentLink),
                                                                                    children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.landscapeApprovalDocumentLink, "?").concat(sasToken)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "INFOSEC APPROVAL STATUS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.infosecApproval ? "Approved" : myBot.infosecApprover === undefined || myBot.infosecApprover == "" || myBot.infosecApprover == null ? "--" : "Rejected"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "INFOSEC APPROVER NAME"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.infosecApprover === undefined || myBot.infosecApprover == "" || myBot.infosecApprover == null ? "--" : myBot.infosecApprover
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "INFOSEC APPROVAL DATE"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.infosecApprovalDate === undefined || myBot.infosecApprovalDate == "" || myBot.infosecApprovalDate == null || myBot.infosecApprovalDate == "2018-12-31" || myBot.infosecApprovalDate == "2018-12-30" ? "--" : convertToDDMMYYYY(myBot.infosecApprovalDate)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "INFOSEC COMMENTS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.infosecComments === undefined || myBot.infosecComments == "" || myBot.infosecComments == null ? "--" : myBot.infosecComments
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                myBot.infosecApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "INFOSEC APPROVAL DOCUMENT LINK"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.infosecApprovalDocumentLink),
                                                                                    children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.infosecApprovalDocumentLink, "?").concat(sasToken)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "FIRST LEVEL GPM APPROVAL STATUS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.firstLevelGpmApprovalStatus ? "Approved" : myBot.firstLevelGpmApprovalStatus === false ? "Rejected" : "--"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "FIRST LEVEL GPM APPROVER NAME"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.firstLevelGpmApprover === undefined || myBot.firstLevelGpmApprover == "" || myBot.firstLevelGpmApprover == null ? "--" : myBot.firstLevelGpmApprover
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "FIRST LEVEL GPM APPROVAL DATE"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.firstLevelGpmApprovalDate === undefined || myBot.firstLevelGpmApprovalDate == "" || myBot.firstLevelGpmApprovalDate == null || myBot.firstLevelGpmApprovalDate == "2018-12-31" || myBot.firstLevelGpmApprovalDate == "2018-12-30" ? "--" : convertToDDMMYYYY(myBot.firstLevelGpmApprovalDate)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "FIRST LEVEL GPM COMMENTS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.firstLevelGpmComment === undefined || myBot.firstLevelGpmComment == "" || myBot.firstLevelGpmComment == null ? "--" : myBot.firstLevelGpmComment
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                myBot.firstLevelGpmApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "FIRST LEVEL GPM APPROVAL DOCUMENT LINK"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.firstLevelGpmApprovalDocumentLink),
                                                                                    children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.firstLevelGpmApprovalDocumentLink, "?").concat(sasToken)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "SECOND LEVEL GPM APPROVAL STATUS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.secondLevelGpmApprovalStatus ? "Approved" : myBot.secondLevelGpmApprovalStatus === false ? "Rejected" : "--"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: " SECOND LEVEL GPM APPROVER NAME"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.secondLevelGpmApprover === undefined || myBot.secondLevelGpmApprover == "" || myBot.secondLevelGpmApprover == null ? "--" : myBot.secondLevelGpmApprover
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "SECOND LEVEL GPM APPROVAL DATE"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.secondLevelGpmApprovalDate === undefined || myBot.secondLevelGpmApprovalDate == "" || myBot.secondLevelGpmApprovalDate == null || myBot.secondLevelGpmApprovalDate == "2018-12-31" || myBot.secondLevelGpmApprovalDate == "2018-12-30" ? "--" : convertToDDMMYYYY(myBot.secondLevelGpmApprovalDate)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "SECOND LEVEL GPM COMMENTS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.secondLevelGpmComment === undefined || myBot.secondLevelGpmComment == "" || myBot.secondLevelGpmComment == null ? "--" : myBot.secondLevelGpmComment
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                myBot.secondLevelGpmApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "SECOND LEVEL GPM APPROVAL DOCUMENT LINK"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.secondLevelGpmApprovalDocumentLink),
                                                                                    children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.secondLevelGpmApprovalDocumentLink, "?").concat(sasToken)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                myBot.kfa == true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).left,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "FIRST LEVEL GFCF APPROVAL STATUS"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.firstLevelgfcfApprovalStatus ? "Approved" : myBot.firstLevelgfcfApprovalStatus === false ? "Rejected" : "--"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).right,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "FIRST LEVEL GFCF APPROVER NAME"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.firstLevelgfcfApprover == "" || myBot.firstLevelgfcfApprover == undefined || myBot.firstLevelgfcfApprover == null ? "--" : myBot.firstLevelgfcfApprover
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).cardRow,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).left,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "FIRST LEVEL GFCF APPROVAL DATE"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.firstLevelGfcfApprovalDate == "2018-12-31" || myBot.firstLevelGfcfApprovalDate == "2018-12-30" || myBot.firstLevelGfcfApprovalDate === undefined || myBot.firstLevelGfcfApprovalDate === null ? "--" : convertToDDMMYYYY(myBot.firstLevelGfcfApprovalDate)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).right,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "FIRST LEVEL GFCF COMMENTS"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.firstLevelGfcfComment == "" || myBot.firstLevelGfcfComment === undefined || myBot.firstLevelGfcfComment == null ? "--" : myBot.firstLevelGfcfComment
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        myBot.firstLevelGfcfApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (botDetailUser_module_default()).center,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        children: "FIRST LEVEL GFCF APPROVAL DOCUMENT LINK"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            target: "_blank",
                                                                                            href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.firstLevelGfcfApprovalDocumentLink),
                                                                                            children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.firstLevelGfcfApprovalDocumentLink, "?").concat(sasToken)
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }) : null,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).left,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: " SECOND LEVEL GFCF APPROVAL STATUS"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.secondLevelGfcfApprovalStatus ? "Approved" : myBot.secondLevelGfcfApprovalStatus === false ? "Rejected" : "--"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).right,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: " SECOND LEVEL GFCF APPROVER NAME"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.secondLevelGfcfApprover === undefined || myBot.secondLevelGfcfApprover == "" || myBot.secondLevelGfcfApprover == null ? "--" : myBot.secondLevelGfcfApprover
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).cardRow,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).left,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "SECOND LEVEL GFCF APPROVAL DATE "
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.secondLevelGfcfApprovalDate === undefined || myBot.secondLevelGfcfApprovalDate == "" || myBot.secondLevelGfcfApprovalDate == null || myBot.secondLevelGfcfApprovalDate == "2018-12-31" || myBot.secondLevelGfcfApprovalDate == "2018-12-30" ? "--" : convertToDDMMYYYY(myBot.secondLevelGfcfApprovalDate)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).right,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "SECOND LEVEL GFCF COMMENTS "
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.secondLevelGfcfComment === undefined || myBot.secondLevelGfcfComment == "" || myBot.secondLevelGfcfComment == null ? "--" : myBot.secondLevelGfcfComment
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : null,
                                                                myBot.secondLevelGfcfApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "SECOND LEVEL GFCF APPROVAL DOCUMENT LINK"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.secondLevelGfcfApprovalDocumentLink),
                                                                                    children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.secondLevelGfcfApprovalDocumentLink, "?").concat(sasToken)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                myBot.cluster == "Global" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).left,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "GCAD APPROVAL STATUS"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.gcadApprovalStatus ? "Approved" : myBot.gcadApprovalStatus === false ? "Rejected" : "--"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).right,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "GCAD APPROVER NAME"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.gcadApprover ? myBot.gcadApprover : "--"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((botDetailUser_module_default()).cardRow),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).left,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "GCAD APPROVAL DATE"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.gcadApprovalDate == "2018-12-31" || myBot.gcadApprovalDate == "2018-12-30" ? "--" : myBot.gcadApprovalDate ? convertToDDMMYYYY(myBot.gcadApprovalDate) : "--"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (botDetailUser_module_default()).right,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "GCAD APPROVER COMMENTS"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: myBot.gcadComments ? myBot.gcadComments : "--"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : null,
                                                                myBot.gCadApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "GCAD APPROVAL DOCUMENT LINK"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.gCadApprovalDocumentLink),
                                                                                    children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.gCadApprovalDocumentLink, "?").concat(sasToken)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "BUSINESS OWNER COMMENTS"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.businessOwnerComments ? myBot.businessOwnerComments : "--"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "LANDSCAPE NAME"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.landscapeId !== null && myBot.landscapeId !== undefined ? myBot.landscapeId == 0 && "Global" || myBot.landscapeId == 1 && "Fusion" || myBot.landscapeId == 2 && "Sirius" || myBot.landscapeId == 3 && "Cordillera" || myBot.landscapeId == 4 && "U2K2" : "--"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                myBot.businessOwnerApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).center,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "BUSINESS OWNER APPROVAL DOCUMENT LINK"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    href: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.businessOwnerApprovalDocumentLink),
                                                                                    children: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(myBot.businessOwnerApprovalDocumentLink)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).left,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "KFA IUC"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: myBot.kfaIuc ? "Yes" : myBot.kfaIuc === false ? "No" : "--"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (botDetailUser_module_default()).right,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: "CONTROL IMPACTED"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                    children: (myBot === null || myBot === void 0 ? void 0 : myBot.controlActivityType) ? myBot.controlActivityType : "None"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((botDetailUser_module_default()).cardRow),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (botDetailUser_module_default()).left,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: "Control Number"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: (myBot === null || myBot === void 0 ? void 0 : myBot.controlNumber) ? myBot.controlNumber : "-"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        myBot.firstLevelControlTable === undefined || myBot.firstLevelControlTable == "" || myBot.firstLevelControlTable == null ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (botDetailUser_module_default()).txtCard,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    className: (botDetailUser_module_default()).cardHeading,
                                                                    children: "Approval Control Tables"
                                                                }),
                                                                myBot.firstLevelControlTable != null && myBot.firstLevelControlTable != undefined && myBot.firstLevelControlTable != "null" ? JSON.parse(lodash_default().get(myBot, "firstLevelControlTable", "[]")).map(function(item, index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (botDetailUser_module_default()).controlTable,
                                                                        children: Object.keys(item).map(function(objectItem, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "".concat((botDetailUser_module_default()).cardRow, " ").concat((botDetailUser_module_default()).fullwidth, " ").concat((botDetailUser_module_default()).controlTable),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (botDetailUser_module_default()).center,
                                                                                        children: [
                                                                                            index == 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                children: objectItem ? objectItem.slice(0, 10) : " " + " " + objectItem ? objectItem.slice(10) : 0
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                children: objectItem ? objectItem.slice(0, 7) : " " + " " + objectItem ? objectItem.slice(7) : 0
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                                children: item[objectItem]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }, index)
                                                                            });
                                                                        })
                                                                    });
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botDetailUser_module_default()).mediaContent,
                                            children: [
                                                myBot.botDemoVideo == null || myBot.botDemoVideo == "" || myBot.botDemoVideo == "undefined" || myBot.botDemoVideo == undefined || myBot.botDemoVideo === undefined || myBot.botDemoVideo == "can be empty" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (botDetailUser_module_default()).videWrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                        width: "100%",
                                                        height: "100%",
                                                        controls: true,
                                                        url: "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/botDocuments/").concat(myBot.documentFolderName, "/").concat(myBot.botDemoVideo, "?").concat(sasToken)
                                                    })
                                                }),
                                                currentDocumentExtension !== "" && currentDocumentExtension !== undefined && currentDocumentExtension !== null && myBot[selectedDropdown] !== null && myBot[selectedDropdown] !== undefined && myBot[selectedDropdown] !== "" && myBot[selectedDropdown] !== "NA" && myBot[selectedDropdown] !== "NULL" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (botDetailUser_module_default()).pdfWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (botDetailUser_module_default()).pdfHead,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: (botDetailUser_module_default()).pdfText,
                                                                    children: "Documents"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (botDetailUser_module_default()).threeDots,
                                                                    onClick: openDocumentSelector,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                        name: "threeDots",
                                                                        className: (botDetailUser_module_default()).plusIcon
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        documentDropdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (botDetailUser_module_default()).dropdownWrapper,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (botDetailUser_module_default()).dropdown,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                                                    dropdownParent: "documentType",
                                                                    values: documentTypes,
                                                                    getDropdownValue: gotDropDownValue,
                                                                    haveRelated: null,
                                                                    params: "botDetailDocument",
                                                                    closeAllDropdowns: function() {
                                                                        return setDocumentDropdown(false);
                                                                    }
                                                                })
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (botDetailUser_module_default()).pdfsubHead,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                    name: currentDocumentExtension,
                                                                    className: (botDetailUser_module_default()).icon
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: (botDetailUser_module_default()).pdfText,
                                                                    children: documentAr.filter(function(item) {
                                                                        return item.value == selectedDropdown;
                                                                    })[0].title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    onClick: function() {
                                                                        window.open("".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/botDocuments/").concat(myBot.documentFolderName, "/").concat(myBot[selectedDropdown], "?").concat(sasToken));
                                                                    },
                                                                    className: (botDetailUser_module_default()).downloadIcon,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                        name: "downloadBlue"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        myBot[selectedDropdown] !== null && myBot[selectedDropdown] !== "" && myBot[selectedDropdown] != "can be empty" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (botDetailUser_module_default()).pdfmainHead,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                                ref: frameRef,
                                                                src: currentDocumentExtension == "pdf" || currentDocumentExtension == "jpg" || currentDocumentExtension == "mp4" ? "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/botDocuments/").concat(myBot.documentFolderName, "/").concat(myBot[selectedDropdown], "?").concat(sasToken) : currentDocumentExtension == "xlsx" || currentDocumentExtension == "xls" || currentDocumentExtension == "doc" || currentDocumentExtension == "docx" ? "https://docs.google.com/viewerng/viewer?embedded=true&url=".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/botDocuments/").concat(myBot.documentFolderName, "/").concat(myBot[selectedDropdown], "?").concat(sasToken) : currentDocumentExtension == "ppt" || currentDocumentExtension == "pptx" || currentDocumentExtension == "msg" ? "https://view.officeapps.live.com/op/embed.aspx?src=".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/botDocuments/").concat(myBot.documentFolderName, "/").concat(myBot[selectedDropdown], "?").concat(sasToken) : "".concat(endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/botDocuments/").concat(myBot.documentFolderName, "/").concat(myBot[selectedDropdown], "?").concat(sasToken),
                                                                type: "application/".concat(currentDocumentExtension),
                                                                width: "100%",
                                                                height: "532px"
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                position: "absolute",
                                                                marginLeft: "200px",
                                                                marginTop: "200px"
                                                            },
                                                            children: "Does not exist"
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                editUser.includes(authData.userType) && props.type != "previewPage" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((botDetailUser_module_default()).getBot, " ").concat((botDetailUser_module_default()).editBotBtn),
                                    onClick: editBot,
                                    children: "Edit This Bot"
                                }) : null
                            ]
                        })
                    }) : null,
                    props.type == "previewPage" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((botDetailUser_module_default()).BotdetailsCard, " container"),
                        children: [
                            similarBots.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (botDetailUser_module_default()).commonText,
                                children: "More similar bots"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botDetailUser_module_default()).parentCard,
                                children: similarBots.map(function(bot, index) {
                                    return index < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (botDetailUser_module_default()).similarCards,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicBotCard["default"], {
                                            data: bot
                                        }, index)
                                    }) : null;
                                })
                            })
                        ]
                    })
                ]
            }),
            reviewModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white w-[900px] relative h-[400px] flex !rounded-lg !rounded-br-[80px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "bg-[#D4E3FD] absolute right-2 top-2 text-[#033166] rounded-full w-6 h-6 flex items-center justify-center",
                            onClick: function() {
                                return setReviewModal(false);
                            },
                            children: "X"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "w-[400px] object-cover rounded-lg rounded-br-[80px]",
                            width: 400,
                            src: bot_approval_img/* default */.Z,
                            alt: "Review Modal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-6 px-10 flex flex-col gap-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-[#005EEF] text-[32px]",
                                    children: "Bot Review"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[#005EEF] text-[16px] !mb-1",
                                            children: "Choose a reviewer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: "!border-b-2 bg-inherit border-[#D4E3FD] w-[400px] h-[40px] p-2",
                                            disabled: true,
                                            value: "Ritika.Kaushik@unilever.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "bg-[#005EEF] p-2 w-[160px] text-white rounded-br-[20px] rounded-tr-[20px] ",
                                    onClick: function() {
                                        props.createTheBot();
                                        setReviewModal(false);
                                    },
                                    children: "Submit Bot Review"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            props.type == "previewPage" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container my-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (botDetailUser_module_default()).combinedBtn,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (botDetailUser_module_default()).rowBtn,
                            onClick: props.backToEdit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                    name: "arrowback",
                                    className: (botDetailUser_module_default()).plusIcon
                                }),
                                "Back to edit mode"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (botDetailUser_module_default()).exportListBtn,
                            onClick: function() {
                                return setReviewModal(true);
                            },
                            children: "Save and Proceed"
                        })
                    ]
                })
            }) : null,
            botModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(getBotModal, {
                setbotModal: setbotModal,
                botName: myBot.processName,
                botID: myBot.botID,
                setSuccessModal: setSuccessModal,
                setBotModal: setbotModal,
                leadPlatform: myBot.leadPlatform,
                technology: myBot.technology,
                globalData: props.globalData,
                data: props.data.data.field_create_bot_component[0].component.content,
                setLoading: setLoading
            }) : null
        ]
    });
}
var botDetailEndUser_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session,
        tokenStatus: state.session.token
    };
};
function botDetailEndUser_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var botDetailEndUser = ((0,es/* connect */.$j)(botDetailEndUser_mapStateToProps, botDetailEndUser_mapDispatchToProps)(index));


/***/ }),

/***/ 71835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20912);
/* harmony import */ var _styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _public_assets_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18023);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14416);
/* harmony import */ var _redux_storeBot_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64362);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49530);








function index(props) {
    var camelize = function camelize(str) {
        return str.toString().replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var _data = props.data, __source = _data._source, leadPlatform = __source.leadPlatform, processName = __source.processName, area = __source.area, subArea = __source.subArea, botID = __source.botID, botExternalId = __source.botExternalId, status = __source.status, cluster = __source.cluster;
    //console.log(leadPlatform, "LEADPLATFORM")
    //console.log(status, "status")
    var goToPage = function() {
        // dispatch(saveCurrentBot(botID))
        // Router.push("/botDetails");
        var encBotId = window.btoa(botID);
        window.open(_utility_endpoints__WEBPACK_IMPORTED_MODULE_6__/* ["default"].redirectUriLogin */ .ZP.redirectUriLogin + "botDetails?botID=".concat(encBotId));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardWrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardHead),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_svg__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            name: camelize(leadPlatform),
                            className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shoppingIcon)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text),
                        style: {
                            lineHeight: "21px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().code),
                                children: [
                                    status === "Demand/New Ideas" ? "D" : "",
                                    botExternalId || botID
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().label),
                                style: {
                                    marginBottom: ".3em"
                                },
                                children: leadPlatform
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardBody),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                        children: processName.length > 30 ? processName.slice(0, 30) + "..." : processName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "".concat((_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().label), " ").concat((_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default())["".concat(status == "Design/Feasibility" ? "designFeasibility" : camelize(status), "Status")]),
                        children: status
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                                children: "Area"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text),
                                children: area
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                                children: "Cluster"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text),
                                children: cluster
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardFoot),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_styles_components_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().actionBtn),
                    onClick: goToPage,
                    children: "View Details"
                })
            })
        ]
    });
}


/***/ }),

/***/ 24923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13301);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _public_assets_svg_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18023);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






function index(props) {
    //console.log(props, "propsss")
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(""), 2), userName = ref[0], setUserName = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var closeIt = function() {
        props.setSuccessModal(false);
        if (props.parent == "createBot") {
            router.push("/botStore");
        }
    };
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        setUserName(auth.name);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().successContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalBox),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalHeader),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                        children: props.data.field_title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalBody),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().status),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_svg_index__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                name: "whitetick"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textBody),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().texthead),
                                    children: [
                                        "Hi ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: userName
                                        })
                                    ]
                                }),
                                props.parent == "createBot" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textcontent),
                                    children: [
                                        " Successfully Created Bot with Bot ID ",
                                        props.botID
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textcontent),
                                    dangerouslySetInnerHTML: {
                                        __html: props.data.field_details
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalFooter),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().combinedBtn),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().exportListBtn),
                            onClick: function() {
                                return closeIt();
                            },
                            children: "Close"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (index);


/***/ }),

/***/ 13301:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"dynamicSuccessModal_liveStatus__x6482","rejectedStatus":"dynamicSuccessModal_rejectedStatus__tY2Is","retiredStatus":"dynamicSuccessModal_retiredStatus__Y5VnL","onHoldStatus":"dynamicSuccessModal_onHoldStatus__HzzZ9","in-ProgressStatus":"dynamicSuccessModal_in-ProgressStatus__jKtEa","inProgressStatus":"dynamicSuccessModal_inProgressStatus__MsboU","uATStatus":"dynamicSuccessModal_uATStatus__kkzdh","initialDemandStatus":"dynamicSuccessModal_initialDemandStatus__73k8o","designFeasibilityStatus":"dynamicSuccessModal_designFeasibilityStatus__S87tu","feasibilityStatus":"dynamicSuccessModal_feasibilityStatus__KHoFr","designStatus":"dynamicSuccessModal_designStatus__U4XeB","ideasStatus":"dynamicSuccessModal_ideasStatus__veqSO","buildStatus":"dynamicSuccessModal_buildStatus__Fq_0z","successContainer":"dynamicSuccessModal_successContainer__W9pJx","modalBox":"dynamicSuccessModal_modalBox__MH7AH","modalHeader":"dynamicSuccessModal_modalHeader__IOozD","content":"dynamicSuccessModal_content__P7gwe","modalBody":"dynamicSuccessModal_modalBody__aT_O6","status":"dynamicSuccessModal_status__GktID","textBody":"dynamicSuccessModal_textBody__zKTQN","texthead":"dynamicSuccessModal_texthead__3QHhZ","textcontent":"dynamicSuccessModal_textcontent__cjJj9","modalFooter":"dynamicSuccessModal_modalFooter__v3r9e","combinedBtn":"dynamicSuccessModal_combinedBtn__XsYwt","rowBtn":"dynamicSuccessModal_rowBtn__waODG","plusIcon":"dynamicSuccessModal_plusIcon__fb5ho","exportListBtn":"dynamicSuccessModal_exportListBtn__l_0Pk","uploadIcon":"dynamicSuccessModal_uploadIcon__alPJi"};

/***/ }),

/***/ 67621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"botDetailUser_liveStatus___BqR9","rejectedStatus":"botDetailUser_rejectedStatus__Da_wK","retiredStatus":"botDetailUser_retiredStatus__M8sL1","onHoldStatus":"botDetailUser_onHoldStatus__XCbOc","in-ProgressStatus":"botDetailUser_in-ProgressStatus__N_QBZ","inProgressStatus":"botDetailUser_inProgressStatus__y_1Hf","uATStatus":"botDetailUser_uATStatus__8NdOb","initialDemandStatus":"botDetailUser_initialDemandStatus__E5UFy","designFeasibilityStatus":"botDetailUser_designFeasibilityStatus__P68Aj","feasibilityStatus":"botDetailUser_feasibilityStatus__hraNp","designStatus":"botDetailUser_designStatus__priTs","ideasStatus":"botDetailUser_ideasStatus__tUUR9","buildStatus":"botDetailUser_buildStatus__GBs4n","botDetailWrapper":"botDetailUser_botDetailWrapper__RTUZI","editBotBtn":"botDetailUser_editBotBtn__8QHik","detailHead":"botDetailUser_detailHead__ywXT8","cardHead":"botDetailUser_cardHead__vFyY_","left":"botDetailUser_left__6n19T","icon":"botDetailUser_icon__93AXD","text":"botDetailUser_text__7UrIC","flexd":"botDetailUser_flexd__akEnL","code":"botDetailUser_code__2lGbr","list":"botDetailUser_list___a0Ff","tooltiptext":"botDetailUser_tooltiptext__M6eRo","info":"botDetailUser_info__aZzR4","label":"botDetailUser_label__U0z3D","statusTagWrapper":"botDetailUser_statusTagWrapper__u6LcQ","editBot":"botDetailUser_editBot__31EYQ","right":"botDetailUser_right__Z4yQ_","backBot":"botDetailUser_backBot__sW9lc","backBotSearch":"botDetailUser_backBotSearch__LcvyV","detailBody":"botDetailUser_detailBody__YGYB5","textualContent":"botDetailUser_textualContent__CHW3F","txtCard":"botDetailUser_txtCard__yhYh2","controlTable":"botDetailUser_controlTable__2RTlj","cardRow":"botDetailUser_cardRow__C8_oe","fullWidth":"botDetailUser_fullWidth__gRy4_","documentLinkHeading":"botDetailUser_documentLinkHeading__obnAI","editRow":"botDetailUser_editRow__6DbtN","input":"botDetailUser_input__Jm2S8","more":"botDetailUser_more__8fPG7","container":"botDetailUser_container__IekSA","loader":"botDetailUser_loader__fmzLu","loader3":"botDetailUser_loader3__Wa8H0","load3":"botDetailUser_load3__KW93J","cardHeading":"botDetailUser_cardHeading__nv9MN","mediaContent":"botDetailUser_mediaContent__bU8Mo","videWrapper":"botDetailUser_videWrapper__ZVVUF","pdfWrapper":"botDetailUser_pdfWrapper__2Uyk_","dropdownWrapper":"botDetailUser_dropdownWrapper__WeyH6","dropdown":"botDetailUser_dropdown__AWQrq","pdfHead":"botDetailUser_pdfHead__YqfJr","pdfText":"botDetailUser_pdfText__mvMeb","threeDots":"botDetailUser_threeDots__8WTIe","pdfsubHead":"botDetailUser_pdfsubHead__EZzsU","downloadIcon":"botDetailUser_downloadIcon___tGYW","pdfmainhead":"botDetailUser_pdfmainhead___PpzG","icard":"botDetailUser_icard__jZzB6","getBot":"botDetailUser_getBot__bHyLo","rollBot":"botDetailUser_rollBot__Juvtz","combinedBtn":"botDetailUser_combinedBtn__VdYhI","rowBtn":"botDetailUser_rowBtn__0F0Wx","plusIcon":"botDetailUser_plusIcon__gbyDR","exportListBtn":"botDetailUser_exportListBtn__nbhOt","uploadIcon":"botDetailUser_uploadIcon__QIARP","BotdetailsCard":"botDetailUser_BotdetailsCard__ubxYb","commonText":"botDetailUser_commonText__tmzdj","parentCard":"botDetailUser_parentCard__yDlo3","similarCards":"botDetailUser_similarCards__ahoju","load":"botDetailUser_load__KknKL"};

/***/ }),

/***/ 20912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"card_liveStatus__V7qYx","rejectedStatus":"card_rejectedStatus__auEub","retiredStatus":"card_retiredStatus__V4jUt","onHoldStatus":"card_onHoldStatus__dyQIf","in-ProgressStatus":"card_in-ProgressStatus__U3BAc","inProgressStatus":"card_inProgressStatus__r_lJB","uATStatus":"card_uATStatus__7Adej","initialDemandStatus":"card_initialDemandStatus__YYKkZ","designFeasibilityStatus":"card_designFeasibilityStatus__kCLm6","feasibilityStatus":"card_feasibilityStatus__MJIAV","designStatus":"card_designStatus__B8WOk","ideasStatus":"card_ideasStatus__qpebi","buildStatus":"card_buildStatus__isvu6","cardWrapper":"card_cardWrapper__M71DO","cardHead":"card_cardHead__NletE","icon":"card_icon__ViIuM","text":"card_text__CRXSK","code":"card_code__ZnxKb","label":"card_label__baOUZ","cardBody":"card_cardBody__Tpxik","title":"card_title__Y8G6d","content":"card_content__D_9_f","cardFoot":"card_cardFoot__pK_BS","actionBtn":"card_actionBtn__8ln3t","listIcon":"card_listIcon__FozAf"};

/***/ }),

/***/ 47169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"getModal_liveStatus__Ymva3","rejectedStatus":"getModal_rejectedStatus__hEyyK","retiredStatus":"getModal_retiredStatus__nwV7h","onHoldStatus":"getModal_onHoldStatus__3IhcN","in-ProgressStatus":"getModal_in-ProgressStatus__Vah2y","inProgressStatus":"getModal_inProgressStatus__IRTXq","uATStatus":"getModal_uATStatus__MjpeL","initialDemandStatus":"getModal_initialDemandStatus__fUiPb","designFeasibilityStatus":"getModal_designFeasibilityStatus__0naa9","feasibilityStatus":"getModal_feasibilityStatus__ND2py","designStatus":"getModal_designStatus__9ph50","ideasStatus":"getModal_ideasStatus__QdWo_","buildStatus":"getModal_buildStatus__3pGBC","editModalWrapper":"getModal_editModalWrapper___X7ib","modalBox":"getModal_modalBox__KIWwp","modalHeader":"getModal_modalHeader__kNUAA","content":"getModal_content__4q5LC","modalBody":"getModal_modalBody__bsqv6","basicForm":"getModal_basicForm__7Hmhb","textBody":"getModal_textBody__9_XD5","texthead":"getModal_texthead__eag1n","textbody":"getModal_textbody__txXC8","row":"getModal_row__jeqTN","inputGroup":"getModal_inputGroup__IteFv","labelStyle":"getModal_labelStyle__qKvOZ","errorMessage":"getModal_errorMessage__20Y__","input":"getModal_input__FwXq2","right":"getModal_right__PUBfE","more":"getModal_more__e4DWR","errorBorder":"getModal_errorBorder__HKxJY","modalFooter":"getModal_modalFooter__GOO18","combinedBtn":"getModal_combinedBtn__DKY_O","rowBtn":"getModal_rowBtn__me0ke","plusIcon":"getModal_plusIcon__ecfHA","exportListBtn":"getModal_exportListBtn__7zRQA","uploadIcon":"getModal_uploadIcon__hMOHR"};

/***/ })

}]);